import "./ballon.css.ts.vanilla.mjs";
var a = "p273__ballon-a8f6_fc79fb26b__1rw0nla2", l = "p273__ballon-a8f6_fc79fb26b__1rw0nla1", b = "p273__ballon-a8f6_fc79fb26b__1rw0nla0";
export {
  a as ballonStyle,
  l as darkTheme,
  b as lightTheme
};
//# sourceMappingURL=ballon.mjs.map
